<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">400</h1>
            <h4 class="pt-3">{{ $t("errors.notfounddata") }}</h4>
            <p v-if="errorMessage">{{ errorMessage }}</p>
            <p class="text-muted">{{ $t("errors.problemaccess") }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import jwtMixin from "../../mixins/jwtMixin";

export default {
  name: "Page400",
  mixins: [jwtMixin],
  props: ["error"],
  created() {
    this.$i18n.locale = this.jwtLanguage();
    this.$i18n.fallbackLocale = this.jwtLanguage();
    this.errorMessage = this.error;
  },
  data() {
    return {
      errorMessage: null,
    };
  },
};
</script>
